import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: '/api/admin',
  timeout: 10000
})

// 请求拦截器：自动携带 token
service.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
}, error => Promise.reject(error))

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('admin_token')
      window.location.hash = '#/login'
      return Promise.reject(error)
    }
    Message.error('网络错误，请检查后端服务是否启动')
    return Promise.reject(error)
  }
)

export default service

// 图片空间 API
export const imageApi = {
  // 上传图片
  upload(file) {
    const formData = new FormData()
    formData.append('file', file)
    return service.post('/images', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  // 分页列表
  list(page = 1, pageSize = 20) {
    return service.get('/images', { params: { page, page_size: pageSize } })
  },
  // 删除图片
  delete(id) {
    return service.delete(`/images/${id}`)
  }
}

// 平台客户管理 API（超管用）
export const platformCustomerApi = {
  getCustomers(params) {
    return service.get('/platform/customers', { params })
  },
  updateStatus(id, status) {
    return service.put(`/platform/customers/${id}`, { status })
  },
  deleteCustomer(id) {
    return service.delete(`/platform/customers/${id}`)
  },
  chargeBalance(id, data) {
    return service.post(`/platform/customers/${id}/balance`, data)
  },
  getBalanceLogs(id, params) {
    return service.get(`/platform/customers/${id}/balance-logs`, { params })
  }
}

// 页面 API
export const pageApi = {
  // 设为首页
  setHome(id) {
    return service.put(`/pages/${id}/home`)
  },
  // 批量更新排序
  updateSort(sortData) {
    return service.put('/pages/sort', sortData)
  },
  // 更新页面
  update(id, data) {
    return service.put(`/pages/${id}`, data)
  }
}

// 平台管理 API（超管用）
export const platformApi = {
  impersonateTenant(tenantId) {
    return service.post(`/platform/tenants/${tenantId}/impersonate`)
  },
  getTenantFeatures(tenantId) {
    return service.get(`/platform/tenant/${tenantId}/features`)
  },
  updateTenantFeatures(tenantId, features) {
    return service.put(`/platform/tenant/${tenantId}/features`, { features })
  }
}

// 个人中心 API
export const profileApi = {
  me() {
    return service.get('/me')
  },
  updateProfile(data) {
    return service.put('/profile', data)
  }
}

// 收银台员工 API
export const staffApi = {
  list: () => service.get('/staffs'),
  create: (data) => service.post('/staffs', data),
  update: (id, data) => service.put(`/staffs/${id}`, data),
  delete: (id) => service.delete(`/staffs/${id}`),
  login: (pin) => service.post('/staffs/login', { pin }),
  stats: (params) => service.get('/staffs/stats', { params })
}

// 收银台扩展 API（订单查询、挂单、库存日志）
export const cashierApi = {
  orders: (params) => service.get('/cashier/orders', { params }),
  park: (data) => service.post('/cashier/park', data),
  parks: () => service.get('/cashier/parks'),
  deletePark: (id) => service.delete(`/cashier/parks/${id}`),
  stockLogs: (params) => service.get('/stock-logs', { params })
}

// 订单管理 API
export const orderApi = {
  list: (params) => service.get('/orders', { params }),
  detail: (id) => service.get(`/orders/${id}`),
  update: (id, data) => service.put(`/orders/${id}`, data),
  cancel: (id) => service.put(`/orders/${id}/cancel`),
  refund: (id, data) => service.post(`/orders/${id}/refund`, data),
  refundLogs: (id) => service.get(`/orders/${id}/refunds`)
}

// 营销管理 API
export const marketingApi = {
  // 优惠券
  coupons: (params) => service.get('/coupons', { params }),
  createCoupon: (data) => service.post('/coupons', data),
  updateCoupon: (id, data) => service.put(`/coupons/${id}`, data),
  deleteCoupon: (id) => service.delete(`/coupons/${id}`),
  // 秒杀
  seckills: (params) => service.get('/seckills', { params }),
  createSeckill: (data) => service.post('/seckills', data),
  updateSeckill: (id, data) => service.put(`/seckills/${id}`, data),
  deleteSeckill: (id) => service.delete(`/seckills/${id}`),
  // 买送
  buygets: (params) => service.get('/buygets', { params }),
  createBuyGet: (data) => service.post('/buygets', data),
  updateBuyGet: (id, data) => service.put(`/buygets/${id}`, data),
  deleteBuyGet: (id) => service.delete(`/buygets/${id}`),
  // 抢购
  rushbuys: (params) => service.get('/rushbuys', { params }),
  createRushBuy: (data) => service.post('/rushbuys', data),
  updateRushBuy: (id, data) => service.put(`/rushbuys/${id}`, data),
  deleteRushBuy: (id) => service.delete(`/rushbuys/${id}`),
  // 商品列表（用于下拉选择）
  products: (params) => service.get('/products', { params })
}
